import Musical from './Musical';

export default Musical;